<template>
  <div>
    <el-select v-bind="$props" v-model="currentValue" multiple @change="changeVal" placeholder="请选择默认值">
      <el-option v-for="item in dataset" :key="item.key" :label="item.value" :value="item.value" value-key="key">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import bus from '@/bus'
export default {
  props: ['value'],
  data() {
    return {
      dataset: []
    }
  },
  mounted() {
    bus.$on('changeSelect', data => {
      this.dataset = data
    })
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || {}
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    changeVal(val, lr) {
      this.$emit('change', val, lr)
    }
  }
}
</script>

<style>
</style>
